export default __webpack_public_path__ + "static/media/co_national_front.bc651338.jpeg";